enum Mode {
    AddWord = "ADD_WORD",
    AddVersion = "ADD_VERSION"
}


export {Mode}